import { Calendar, Draggable } from 'fullcalendar';
import frLocale from '@fullcalendar/core/locales/fr';

export default function init_render(IconsView, iconsViewCache) {

IconsView.prototype.render = function (node) {
        const myself = this;

        this.containerView = $('<div class="iv__view"></div>');

        this.scrollLast = $(window).scrollTop();

        // Buttons bar
        let formData = getFormData(this.element);
        myself.onUnload(this.element);
        this.element.html('');
        this.element.append(this.containerView);
        if (this.template && this.template.toolbar) {
            myself.renderToolbar(this.template.toolbar, this.element, 'iv__toolbar ' + myself.clsBarTop, false, formData);
        }
        this.element.data('plugin', this);

        // Buttons bar
        if (this.template && this.template.buttons) {
            myself.renderToolbar(this.template.buttons, this.element, 'iv__toolbar ' + myself.clsBarBot, true, formData);
        }

        // breadcrumb
        myself.renderBreadcrumb();

        // autofix empty path
        if (!this.path) this.path = [];

        // Defined group Tab mode
        if (this.options.features.tab && typeof this.options.features.tab === 'object') {
            this.tabMode = 'defined';

            let dataNode;
            if (node) {
                dataNode = node;
            } else if (!this.dataNode) {
                dataNode = this.data;
            } else {
                dataNode = this.dataNode;
            }

            // Find missing groups
            const detectedGroups = {};
            $.each(dataNode, (index, item) => {
                detectedGroups[item.group] = 1;
            });


            // Loop for each tabs group
            $.each(this.options.features.tab, (index, iconData) => {
                if (iconData) {
                    detectedGroups[iconData.id] = 0;

                    const filteredNode = [];
                    $.each(dataNode, (index, item) => {
                        if (item.group == iconData.id || !item.group) {
                            filteredNode.push(item);
                        }
                    });

                    /*
                    if (filteredNode.length < 1 || (filteredNode.length == 1 && filteredNode[0].special)) {
                        tabHeader.hide();
                    } else {
                        tabsHeader.append(tabHeader);
                        tabsContainer.append(tabContain);
                        tabHeader.show();
                    }
                     */

                    myself.addTab(iconData, filteredNode);
                }
            });

            // Orphan groups
            $.each(detectedGroups, (index, iconData) => {
                if (iconData) {
                    iconData = {
                        id: index,
                        label: index,
                        icon: '',
                    };

                    const filteredNode = [];
                    $.each(dataNode, (index, item) => {
                        if (item.group == iconData.id || !item.group) {
                            filteredNode.push(item);
                        }
                    });

                    myself.addTab(iconData, filteredNode);
                }
            });

            myself.reloadInput = true;

            // droppable Tabs
            var tabsContainer = this.containerView.find('.iv__tabs');
            myself.renderDroppable(tabsContainer);

            // Rollback for notabs
            if (!tabsContainer.find('.iv__tabs__pane').length) {
                this.tabMode = null;
                this.renderFrame(node);
            }
        }
        // First item Tab mode
        else if (this.options.features.tab && this.path.length == 0) {
            this.tabMode = 'first';
            if (node) {
                this.dataNode = node;
            } else {
                this.dataNode = node = this.data;
            }

            this.element.data('plugin', this);

            // Loop for each icons
            $.each(node, (index, iconData) => {
                if (iconData) {
                    myself.addTab(iconData, iconData.childs);
                }
            });

            myself.reloadInput = true;

            // droppable Tabs
            var tabsContainer = this.containerView.find('.iv__tabs');
            myself.renderDroppable(tabsContainer);
        }
        // normal mode
        else {
            this.tabMode = null;
            this.renderFrame(node);
        }

        // input refresh
        if (myself.reloadInput) {
            if (myself.events.refreshInput) myself.events.refreshInput(myself.element);
        }

        // scroll
        myself.scroll();

        if (!myself.dataNodeParent.iconSize) myself.dataNodeParent.iconSize = {};
        const currentIconSize = myself.dataNodeParent.iconSize[myself.view];

        myself.setIconSize((currentIconSize) || myself.viewThumbsHeight);

        myself.changeSelection();

        // event
        if (myself.events.render) myself.events.render(myself.element);
    };


IconsView.prototype.addTab = function (iconData, filteredNode) {
        const myself = this;
        if (!this.containerView.find('.iv__tabs').length) {
            const instanceUid = myself.name || myself.element.attr('id') || parseInt(Math.random() * 1000000);
            var tabsContainer = $('<div class="iv__tabs tabs" name="tabs-iconview-' + instanceUid + '" id="tabs-iconview-' + instanceUid + '"></div>');
            var tabsHeaderWrap = $('<div class="iv__tabs__nav__wrap tabs__nav__wrap"><ul class="tabs__nav iv__tabs__nav" id="tab-iconview-btns-' + instanceUid + '"></ul></div>');
            var tabsHeader = tabsHeaderWrap.find('.iv__tabs__nav');

            tabsContainer.append(tabsHeaderWrap);
            this.containerView.append(tabsContainer);

            tabsContainer.on('tabsactivate', (event, ui) => {
                myself.fixedTab[myself.templateName] = ui.newTab.data('id');

                const tabContain = $(ui.newPanel);
                if (tabContain.data('rendered') === false) {
                    myself.renderFrame(tabContain.data('node'), tabContain, false);
                    if (myself.events.render) myself.events.render(tabContain);
                }

                myself.setIconSize(myself.viewThumbsHeight, tabContain);
            });
        } else {
            var tabsContainer = this.containerView.find('.iv__tabs');
            var tabsHeader = this.containerView.find('.iv__tabs__nav');
        }

        // Loop for each icons
        if (iconData.special == 'root' || iconData.special == 'parent') return true;
        const data = iconData;
        let currentIconReact;
        let currentIcon;
        let currentType = (iconData.type) ? iconData.type : 'item';
        if (typeof currentType == 'string') currentType = [currentType];
        let currentClass = (iconData.class) ? iconData.class : [];
        if (typeof currentClass === 'object') currentClass = currentClass.join(' ');
        const currentRandomId = parseInt(Math.random() * 1000000000);
        const currentClassAll = [
            'iv__tabs__btn',
            'tabs__btn',
            'tab-btn',
            'iv__item iv__item--' + data.id,
            'iv__item--' + data.id + '--' + currentRandomId,
            currentClass
        ];
        $.each(currentType, function() {
            currentClassAll.push('iv__item--type-' + this);
        })
        if (iconData.ref) currentClassAll.push('iv__item--ref-' + iconData.ref);
        let tabName = formatFilename(data.label);
        if (!tabName) tabName = formatFilename(data.icon);
        var currentTabNb = tabsContainer.children().length-1;
        var isActive = (myself.fixedTab[myself.templateName] == data.id)?true:false;
        if (isActive) {
            currentClassAll.push('ui-tabs-active ui-state-active');
            tabsContainer.attr('value', currentTabNb);
        }

        const instanceUid = myself.name || myself.element.attr('id') || parseInt(Math.random() * 1000000);
        const scopedTabId = 'tab-' + instanceUid + '-' + tabName;
        const tabHeader = $(`
        <li id="btn-${scopedTabId}" data-id="${data.id}" class="tabs__btn tab-pointage-tab ui-state-default ui-tab ui-tabs-tab ${currentClassAll.join(' ')}"
            role="tab"
            aria-controls="${scopedTabId}"
            aria-selected="${data.active ? 'true' : 'false'}"
            aria-expanded="${data.active ? 'true' : 'false'}"
            aria-labelledby="ui-id-${data.uiId || scopedTabId}">
            <a href="#${scopedTabId}" class="tabs__link ui-tabs-anchor" draggable="false" tabindex="-1" id="ui-id-${data.uiId || scopedTabId}">
                <span class="tabs__ico icon ico" data-ico="${data.icon}">
                    <span class="ico" data-size="32" data-ico="${data.icon}" style="width: 32px; height: 32px;">
                        ${myself.renderIconImage('small', data.icon, data)}
                    </span>
                </span>
                ${data.label ? `<span class="tabs__label label">${data.label}</span>` : ''}
            </a>
        </li>
        `);
        const tabContain = $('<div class="iv__tabs__pane tabs__pane tabs__pane--stick tab-content tab-' + tabName + '" id="' + scopedTabId + '"></div>');
        tabContain.data('item', tabHeader);

        tabHeader.data('type', currentType);
        tabHeader.data('plugin', myself);
        tabHeader.data('data', data);

        if (filteredNode.length < 1 || (filteredNode.length == 1 && filteredNode[0].special && this.options.features.tab !== true)) {
            tabHeader.hide();
        } else {
            tabsHeader.append(tabHeader);
            tabsContainer.append(tabContain);
            tabHeader.show();
        }

        if (tabsHeader.children().length > 1 || this.options.features.tab === true) tabsHeader.show();
        else tabsHeader.hide();

        tabContain.data('node', filteredNode);
        if (tabsHeader.children().length < 2 || isActive) {
            myself.renderFrame(filteredNode, tabContain, false);
        } else {
            tabContain.data('rendered', false);
        }
    }


IconsView.prototype.renderDroppable = function (element) {
        const myself = this;
        // Enable drop on Containers
        if (this.options.features.droppable) {
            this.element.addClass('iv--feature-droppable');
            $.each(this.options.features.droppable, function (indexDrop, columnDrop) {
                const target = [];
                let accept = [];
                const dropProperties = this;

                for (var i = 0; i < this.target.length; i++) {
                    var currentEl = this.target[i];
                    if (currentEl == 'ref') currentEl = 'REF';
                    else currentEl = '.iv__item--type-' + currentEl;
                    target.push(currentEl);
                }

                if (this.accept instanceof Array) {
                    for (var i = 0; i < this.accept.length; i++) {
                        var currentEl = this.accept[i];
                        if (currentEl == 'ref') currentEl = 'REF';
                        else currentEl = '.iv__item--type-' + currentEl;
                        accept.push(currentEl);
                    }
                } else {
                    for (var currentEl in this.accept) {
                        if (currentEl == 'ref') currentEl = 'REF';
                        else currentEl = '.iv__item--type-' + currentEl;
                        if (currentEl) accept.push(currentEl);
                    }
                }
                const dropableTarget = element.closest('.iv').find(target.join(', '));
                $.each(this.accept, (acceptIndex, acceptName) => {
                    if (acceptName instanceof Object) acceptName = acceptIndex
                    dropableTarget.data('droppable-' + acceptName, clone(dropProperties));
                });

                let dropableTargetElement = dropableTarget.find('.iv__item__image');
                if (myself.view == 'tree' || myself.view == 'blocks') {
                    dropableTargetElement = dropableTarget.filter('.iv__tabs__btn').find('.iv__item__image');
                }

                dropableTargetElement.each(function() {
                    let acceptInst = accept;
                    let similarRefIndex = acceptInst.indexOf('REF')
                    if (similarRefIndex !== -1) {
                        let similarRef = $(this).closest('.iv__item').attr('class').match(/iv__item--ref-(\d+)/);
                        if (similarRef && similarRef.length > 1) {
                            acceptInst = clone(accept);
                            acceptInst[similarRefIndex] = '.iv__item--ref-'+similarRef[1];
                        }
                    }

                    $(this).droppable({
                        accept: acceptInst.join(', '),
                        tolerance: 'pointer',
                        dropProperties,
                        over(event, ui) {
                            $(event.target.closest('.iv__item')).addClass('iv__item--target');
                            $('.iv__drag').addClass('iv__drag--target');
                            var dragImg = $('.iv__drag .iv__item__image');
                            var dragImgDest = $(event.target).closest('.iv__item').find('.iv__item__image');
                            dragImg.data('originalWidth', dragImg.width()).data('originalHeight', dragImg.height())
                            dragImg.css('position', 'fixed').css('left', dragImgDest.offset().left).css('top', dragImgDest.offset().top - $(document).scrollTop()).css('width', dragImgDest.width()+'px').css('height', dragImgDest.height()+'px');
                            $(event.target.closest('.iv')).addClass('hide-sortable');
                            myself.setCursor('drop');
                        },
                        out(event, ui) {
                            $('.iv__item--target').removeClass('iv__item--target');
                            $('.iv__drag').removeClass('iv__drag--target');
                            var dragImg = $('.iv__drag .iv__item__image');
                            dragImg.css('position', 'relative').css('left', 0).css('top', 0).css('width', dragImg.data('originalWidth')+'px', dragImg.data('originalHeight')+'px')
                            $('.hide-sortable').removeClass('hide-sortable');
                            myself.setCursor('last');
                        },
                        drop(e, ui) {
                            const grid = $(this).closest('.iconGrid');

                            // basics manipulations
                            $('.iv__item--target').removeClass('iv__item--target');
                            $('.hide-sortable').removeClass('hide-sortable');
                            const myself = $(this).closest('.iv__item').data('plugin');
                            const dropped = ui.draggable;
                            let droppedItems = [dropped];
                            let target = $(this).closest('.iv__item');

                            if (!target || !target.length) {
                                target = $(this).find('.iv__item--special-parent');
                            }

                            // find
                            let dropProperties = target.data('droppable-' + $(dropped).data('type'));
                            if (!dropProperties && $(dropped).data('ref') == $(target).data('ref') && target.data('droppable-ref')) dropProperties = target.data('droppable-ref');

                            // selected
                            if (grid.find('.iv__item--selected').length > 0) {
                                droppedItems = grid.find('.iv__item--selected');
                            }

                            // submit
                            myself.submitParent(droppedItems, target, dropProperties);
                        },
                    });
                });
            })
        } else {
            this.element.removeClass('iv--feature-droppable');
        }
    }


IconsView.prototype.renderBreadcrumb = function () {
        const myself = this;
        const { element } = this;

        // fil d'Ariane
        if (this.options.features.breadcrumb == true || (this.options.features.breadcrumb == 'auto' && this.path && this.path.length > 0)) {
            const filAriane = $('<div class="iv__breadcrumb grid-fil-ariane"></div>');
            let count = 0;
            for (let i = 0; i <= this.path.length; i++) {
                const filArianeNodePath = this.path.slice(0, i);
                const filArianeCurrent = myself.loadPath(filArianeNodePath);
                let filArianeType = (filArianeCurrent.type) ? filArianeCurrent.type : 'unknown';
                if (i == 0 && myself.rootType) {
                    filArianeType = myself.rootType;
                    filArianeCurrent.id = myself.rootId;
                }
                if (typeof filArianeType == 'string') filArianeType = [filArianeType];
                const currentClassAll = [
                    'iv__breadcrumb__item',
                    'iv__item',
                    'path-node',
                ];
                $.each(filArianeType, function() {
                    currentClassAll.push('iv__item--type-' + this);
                })
                if (filArianeCurrent.ref) currentClassAll.push('iv__item--ref-' + filArianeCurrent.ref);
                const filArianeNode = $('<span class="' + currentClassAll.join(' ') + '">'
                    + ((i > 0)
                        ? '<div class="iv__item__image iv__breadcrumb__item__image">' + myself.renderIconImage('small', filArianeCurrent.icon) + '</div>'
                            + '<div class="iv__breadcrumb__item__label">' + filArianeCurrent.label + '</div>'
                        : '<div class="iv__item__image iv__breadcrumb__item__image">' + myself.renderIconImage('small', 'place-home') + '</div>'
                            + '<div class="iv__breadcrumb__item__label"></div>'
                    )
                    + '</span>');
                filArianeNode.data('id', filArianeCurrent.id);
                filArianeNode.data('plugin', myself);
                filArianeNode.data('type', filArianeType);
                filArianeNode.data('data', filArianeCurrent);
                if (i == 0 || filArianeCurrent.label) {
                    filArianeNode.data('path', filArianeNodePath);
                    if (i > 0) filAriane.append('<span class="iv__breadcrumb__separator"></span>');
                    filAriane.append(filArianeNode);
                }
                count++;
            }
            element.prepend(filAriane);
            filAriane.find('.path-node').click(function () {
                const button = $(this);
                const grid = $(button).closest('.iconGrid');
                const myself = grid.data('plugin');
                myself.setPath($(this).data('path'), true);
                myself.loadPath(null, true);
                myself.render();
            });

            if (filAriane.children().length <= 1) {
                setTimeout(function() {
                    filAriane.find('.path-node').click();
                }, 10)
            }
        }
    }


IconsView.prototype.renderFrame = function (node, element, subdir) {
        const myself = this;
        let columnData = '';

        if (myself.options.event.backup) {
            myself.options.event = myself.options.event.backup;
        }

        if (!subdir) {
            if (node) {
                myself.dataNode = node;
            } else if (!myself.dataNode) {
                myself.dataNode = myself.data;
            }
            node = myself.dataNode;
        }

        if (!element) element = myself.containerView;

        // prepare container
        myself.items = [];
        element.data('rendered', true);
        element.data('plugin', myself);

        // generic menu context
        const menuSortItems = [
            myself.menuOption('Nom', 'media-text', { action: 'sort', order: 'name' }),
        ];
        if (myself.template && myself.template.view && myself.template.view.table) {
            $.each(myself.template.view.table, (indexView, column) => {
                const label = (column.label) ? column.label : '';
                if (column.type != 'action' && column.type != 'icon' && column.type != 'label') {
                    menuSortItems.push(myself.menuOption(column.label, 'media-text', {
                        action: 'sort',
                        order: column.name,
                        type: column.type,
                    }));
                }
            });
        }

        myself.globalMenu = {
            display: {
                name: 'Affichage',
                icon: 'app',
                items: {
                    view_auto: myself.menuOption('Automatique', 'fa-magic', { action: 'setView', view: 'auto' }),
                    sep: '-',
                    view_mosaic: myself.menuOption('Mosaïque', 'fa-th', { action: 'setView', view: 'mosaic' }),
                    view_icons: myself.menuOption('Icônes', 'fa-th-large', { action: 'setView', view: 'icons' }),
                    view_list: myself.menuOption('Liste', 'fa-list', { action: 'setView', view: 'list' }),
                    view_table: myself.menuOption('Tableau', 'fa-table', { action: 'setView', view: 'table' }),
                    view_tree: myself.menuOption('Arbre', 'fa-sitemap', { action: 'setView', view: 'tree' }),
                    view_blocks: myself.menuOption('Blocs', 'fa-cubes', { action: 'setView', view: 'blocks' }),
                    view_thumbs: myself.menuOption('Miniatures', 'fa-images', { action: 'setView', view: 'thumbnails' }),
                    view_summary: myself.menuOption('Résumé', 'fa-file-alt', { action: 'setView', view: 'summary' }),
                    view_preview: myself.menuOption('Aperçu', 'fa-eye', { action: 'setView', view: 'preview' }),
                    view_slideshow: myself.menuOption('Diaporama', 'fa-film', { action: 'setView', view: 'slideshow' }),
                    view_calendar: myself.menuOption('Calendrier (Mois)', 'fa-calendar', { action: 'setView', view: 'calendar' }),
                    view_calendar_week: myself.menuOption('Calendrier (Semaine)', 'fa-calendar', { action: 'setView', view: 'calendar-week' }),
                    view_calendar_day: myself.menuOption('Calendrier (Jour)', 'fa-calendar', { action: 'setView', view: 'calendar-day' }),
                },
            },
        };

        if (myself.options.features.reorganize) {
            myself.globalMenu.sort = {
                name: 'Trier',
                icon: 'media-text',
                items: menuSortItems,
            };
        }

        myself.globalMenu.refresh = myself.menuOption('Actualiser', 'arrow-do-refresh', { action: 'reload' });

        // VIEW container
        myself.preview = null;
        switch (myself.view) {
        // Table view
        case 'table':
            myself.container = $('<table class="t_info"></table>');
            // read columns
            var columns = new Array();
            if (myself.template && myself.template.view && myself.template.view.table) {
                $.each(myself.template.view.table, (indexView, column) => {
                    const label = (column.label) ? column.label : '';
                    if (column.type == 'action') {
                        columnData = '<th class="iv__item__action">' + label + '</th>';
                    } else if (column.type == 'label') {
                        columnData = '<th class="iv__item__name" data-sort="name">' + label + '</th>';
                    } else if (column.type == 'icon') {
                        const currentSize = (column.size && isNumeric(column.size)) ? column.size : 24;
                        columnData = '<th class="iv__item__image" style="width: ' + (parseInt(currentSize) + 10) + 'px;">' + ((currentSize > 24) ? label : '') + '</th>';
                    } else {
                        columnData = '<th '
                                + 'data-sort="' + column.name + '" '
                                + ((column.type) ? 'data-type="' + column.type + '" ' : '')
                                + ((column.size) ? 'style="width:' + column.size + '%;" ' : '')
                                + '>' + label + '</th>';
                    }
                    columns.push(columnData);
                });
            }
            var containerHeader = '<tr>'
                    + columns.join()
                    + '</tr>';
            myself.container.append(containerHeader);


            // Header Click
            if (myself.options.features.reorganize) {
                myself.container.find('th[data-sort]').click(function () {
                    const button = $(this);
                    const grid = $(button).closest('.iconGrid');
                    myself.action({
                        action: 'sort',
                        order: button.data('sort'),
                        type: button.data('type'),
                    }, grid);
                });
            } else {
                myself.container.find('th[data-sort]').css('cursor', 'default')
            }
            break;

        case 'tree':
        case 'blocks':
            myself.container = $('<ol></ol>');
            break;

        // Preview view
        case 'preview':
            myself.container = $('<div></div>');
            myself.preview = $('<div class="iv__preview private"></div>');
            if (myself.options.event.leftClick != 'select1 ') {
                myself.options.event.backup = clone(myself.options.event);
                myself.options.event.doubleClick = myself.options.event.leftClick;
                myself.options.event.leftClick = 'select1';
            }
            break;

        // Slideshow view
        case 'slideshow':
            myself.container = $('<div></div>');
            myself.preview = $('<div class="iv__preview private"></div>');
            myself.preloadPreviewPane();
            if (myself.options.event.leftClick != 'select1 ') {
                myself.options.event.backup = clone(myself.options.event);
                myself.options.event.doubleClick = myself.options.event.leftClick;
                myself.options.event.leftClick = 'select1';
            }
            break;

        // Calendar views
        case 'calendar':
        case 'calendar-week':
        case 'calendar-day':
            myself.container = $('<div class="fullCalendar"></div>');
            break;

        // generic view
        default:
            myself.container = $('<div></div>');
            break;
        }
        myself.containerView.addClass('iv__view iv__view--' + myself.view + ' view view-' + myself.view);
        element.append(myself.container);
        if (myself.preview) {
            element.append(myself.preview);
        }

        // View post change
        // eslint-disable-next-line default-case
        switch (myself.view) {
        // calendar views
        case 'calendar':
        case 'calendar-week':
        case 'calendar-day':
            // Create layout for sidebar + calendar
            const calendarLayout = $('<div class="iv__calendar-layout"></div>');
            myself.sidebar = $('<div class="iv__sidebar"><div class="iv__sidebar__header">'+__('Éléments intemporels')+'</div><div class="iv__sidebar__content iv__container"></div></div>');
            myself.calendarContainer = $('<div class="iv__calendar-container"></div>');

            calendarLayout.append(myself.sidebar);
            calendarLayout.append(myself.calendarContainer);

            myself.container = calendarLayout;
            myself.sidebarContainer = myself.sidebar.find('.iv__sidebar__content');

            element.empty().append(myself.container);

            const calendarTarget = myself.calendarContainer;

            // Determine initial view
            let calendarInitialView = 'dayGridMonth';
            if (myself.view === 'calendar-week') calendarInitialView = 'timeGridWeek';
            else if (myself.view === 'calendar-day') calendarInitialView = 'timeGridDay';

            // Validate initial date
            let calendarInitialDate = myself.date;
            if (!calendarInitialDate || !(calendarInitialDate instanceof Date) || isNaN(calendarInitialDate.getTime())) {
                calendarInitialDate = new Date();
            }

            myself.calendar = new Calendar(calendarTarget[0], {
                initialView: calendarInitialView,
                initialDate: calendarInitialDate,
                locale: frLocale,
                allDayText: 'Global',
                editable: true,
                firstDay: 1,
                height: 'parent',
                droppable: true,
                headerToolbar: {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay'
                },
                eventContent(arg) {
                    const iconEl = arg.event.extendedProps.iconElement;
                    if (iconEl && iconEl.length) {
                        const clone = iconEl.clone(true, true);
                        return { domNodes: [clone[0]] };
                    }
                    return { html: '<span>' + (arg.event.title || '') + '</span>' };
                },
                eventClick(info) {
                    info.jsEvent.preventDefault();
                    info.jsEvent.stopPropagation();
                    const itemData = info.event.extendedProps.itemData;
                    const iconEl = info.event.extendedProps.iconElement;
                    if (iconEl && iconEl.length) {
                        myself.iconTrigger(iconEl, 'leftClick');
                    }
                },
                eventDrop(info) {
                    const itemData = info.event.extendedProps.itemData;
                    if (itemData && info.event.start) {
                        let newStart = info.event.startStr.substring(0, 19).replace('T', ' ');
                        let newEnd = info.event.endStr ? info.event.endStr.substring(0, 19).replace('T', ' ') : null;

                        if (newStart.length === 10) newStart += ' 00:00:00';
                        if (newEnd && newEnd.length === 10) newEnd += ' 00:00:00';

                        // If FullCalendar lost the end date but the original item had one, calculate it to preserve duration
                        if (!newEnd) {
                            const dateFields = myself.getDateFields(itemData.type);
                            if (dateFields && dateFields.length > 1 && itemData.data) {
                                let origStartStr = itemData.data[dateFields[0]];
                                let origEndStr = itemData.data[dateFields[1]];
                                if (origStartStr && origEndStr) {
                                    let parseLocal = (str) => {
                                        let s = str.replace(' ', 'T');
                                        if (s.length === 10) s += 'T00:00:00';
                                        return new Date(s);
                                    };
                                    let origStart = parseLocal(origStartStr);
                                    let origEnd = parseLocal(origEndStr);

                                    if (origStart && origEnd && !isNaN(origStart.getTime()) && !isNaN(origEnd.getTime())) {
                                        let durationMs = origEnd.getTime() - origStart.getTime();
                                        if (durationMs > 0) {
                                            let computedEnd = new Date(info.event.start.getTime() + durationMs);
                                            const pad = (n) => n < 10 ? '0' + n : n;
                                            if (info.event.allDay) {
                                                newEnd = computedEnd.getUTCFullYear() + '-' + pad(computedEnd.getUTCMonth() + 1) + '-' + pad(computedEnd.getUTCDate()) + ' ' +
                                                         pad(computedEnd.getUTCHours()) + ':' + pad(computedEnd.getUTCMinutes()) + ':' + pad(computedEnd.getUTCSeconds());
                                            } else {
                                                newEnd = computedEnd.getFullYear() + '-' + pad(computedEnd.getMonth() + 1) + '-' + pad(computedEnd.getDate()) + ' ' +
                                                         pad(computedEnd.getHours()) + ':' + pad(computedEnd.getMinutes()) + ':' + pad(computedEnd.getSeconds());
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        myself.submitDateChange(itemData, newStart, newEnd);
                    }
                },
                eventReceive(info) {
                    const itemData = info.event.extendedProps.itemData;
                    if (itemData && info.event.start) {
                        let newStart = info.event.startStr.substring(0, 19).replace('T', ' ');
                        let newEnd = info.event.endStr ? info.event.endStr.substring(0, 19).replace('T', ' ') : null;

                        if (newStart.length === 10) newStart += ' 00:00:00';
                        if (newEnd && newEnd.length === 10) newEnd += ' 00:00:00';

                        myself.submitDateChange(itemData, newStart, newEnd);
                    }
                },
                eventDragStop(info) {
                    // Check if dropped into the sidebar
                    const sidebar = myself.sidebarContainer;
                    if (!sidebar || !sidebar.length) return;

                    const offset = sidebar.offset();
                    const x = info.jsEvent.pageX;
                    const y = info.jsEvent.pageY;

                    if (x >= offset.left && x <= offset.left + sidebar.outerWidth() &&
                        y >= offset.top && y <= offset.top + sidebar.outerHeight()) {

                        const itemData = info.event.extendedProps.itemData;
                        if (itemData) {
                            myself.submitDateChange(itemData, null, null);
                        }
                    }
                },
                eventResize(info) {
                    const itemData = info.event.extendedProps.itemData;
                    if (itemData && info.event.start) {
                        let newStart = info.event.startStr.substring(0, 19).replace('T', ' ');
                        let newEnd = info.event.endStr ? info.event.endStr.substring(0, 19).replace('T', ' ') : null;

                        if (newStart.length === 10) newStart += ' 00:00:00';
                        if (newEnd && newEnd.length === 10) newEnd += ' 00:00:00';

                        myself.submitDateChange(itemData, newStart, newEnd);
                    }
                },
                datesSet(dateInfo) {
                    // Use currentStart (actual month/week/day start), NOT start (visible range start)
                    myself.date = dateInfo.view.currentStart;

                    // Sync IconsView view when user switches via FullCalendar toolbar buttons
                    const fcViewType = dateInfo.view.type;
                    let ivView = 'calendar';
                    if (fcViewType === 'timeGridWeek') ivView = 'calendar-week';
                    else if (fcViewType === 'timeGridDay') ivView = 'calendar-day';

                    if (myself.view !== ivView) {
                        myself.view = ivView;
                        myself.fixedView[myself.templateName] = ivView;
                    }
                },
                eventDidMount(info) {
                    // Attach right-click context menu to rendered calendar events
                    $(info.el).on('contextmenu', function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        const iconEl = info.event.extendedProps.iconElement;
                        if (iconEl && iconEl.length) {
                            myself.iconTrigger(iconEl, 'rightClick');
                        }
                        return false;
                    });
                },
                dateClick(info) {
                    // Double-click on empty cell → execute the "action" config
                    const addActionName = myself.template && myself.template.view && myself.template.view.calendar && myself.template.view.calendar.action;
                    if (!addActionName) return;

                    const now = Date.now();
                    if (myself._lastDateClick && myself._lastDateClickDate === info.dateStr && (now - myself._lastDateClick) < 400) {
                        // Double-click detected
                        myself._lastDateClick = null;
                        myself._lastDateClickDate = null;

                        // Look up the action from the parent node's actions
                        const actionObj = clone(myself.options.actions && myself.options.actions[addActionName]);
                        if (actionObj) {
                            // si l'objet à une url, il faut lui ajouter la date clicked.
                            if (actionObj.url) {
                                // trouver nom du paramètre de date
                                const dateField = myself.template.view.calendar.field ?? 'date';
                                actionObj.url += '?'+dateField+'='+info.dateStr;
                            }
                            myself.action(actionObj, myself.element.find('.iconGrid'));
                        }
                    } else {
                        myself._lastDateClick = now;
                        myself._lastDateClickDate = info.dateStr;
                    }
                },
            });
            myself.calendar.render();

            // Initialize Draggable for sidebar items
            new Draggable(myself.sidebarContainer[0], {
                itemSelector: '.iv__item',
                eventData: function(eventEl) {
                    const $el = $(eventEl);
                    const data = $el.data('data');
                    return {
                        title: data.label || '',
                        duration: '01:00',
                        editable: !!myself.getDateFields(data.type),
                        extendedProps: {
                            iconElement: $el,
                            itemData: data
                        }
                    };
                }
            });

            break;
        }


        // Loop for each icons
        if (node) {
            myself.renderIconsArea(node, element.find('.view'), subdir, myself.path);
        } else if (myself.data.message) {
            myself.onUnload(element);
            element.html('<div class="message ' + myself.data.status + '">' + myself.data.message + '</div>');
        }
        // myself.restoreFilter();

        if (myself.element.find('.iv__container--tmp').length) {
            element.append(myself.element.find('.iv__container--tmp').children()[0]);
            myself.element.find('.iv__container--tmp').hide();
        }


        // Enable drag & drop upload
        if (myself.template && myself.template.upload) {
            element.append(`<div class="iv__upload"><div class="iv__upload__progress iv__upload__progress--global progress b-progress"><div class="iv__upload__progress__bar bar"></div></div><div class="iv__upload__files js-files b-upload__files">
                <div class="js-file-tpl iv__upload__thumb b-thumb" data-id="<%=uid%>" title="<%-name%>, <%-sizeText%>">
                <div class="iv__upload__preview">
                <div class="iv__upload__preview__pic"></div>
                </div>
                <div class="iv__upload__progress progress progress-small"><div class="iv__upload__progress__bar bar"></div></div>
                <div class="iv__upload__name"></div>
                </div>
                </div><div class="iv__upload__message"><div class="iv__upload__title">transfert de fichier</div><div class="iv__upload__nb">1 / 1</div></div></div>`);

            let uploadData = {};
            uploadData[(myself.template.upload.parent) ? myself.template.upload.parent : 'parent'] = (myself.dataNodeParent && myself.dataNodeParent.id) ? myself.dataNodeParent.id : myself.rootId;

            myself.element.find('.iv__upload').slideUp().addClass('iv__upload--hidden');
            myself.element.fileapi({
                url: myself.template.upload.request,
                paramName: (myself.template.upload.field) ? myself.template.upload.field : 'filedata',
                // accept: 'image/*',
                data: uploadData,
                autoUpload: (!myself.template.upload.crop),
                transform: false,
                elements: {
                    list: '.iv__upload__files',
                    progress: '.iv__upload .iv__upload__progress .iv__upload__progress__bar',
                    file: {
                        tpl: '.iv__upload__thumb',
                        preview: {
                            el: '.iv__upload__preview',
                            width: 256,
                            height: 180,
                        },
                        upload: { show: '.iv__upload__progress' },
                        complete: { hide: '.iv__upload__progress' },
                        progress: '.iv__upload__progress .iv__upload__progress__bar',
                    },
                    dnd: {
                        el: '.iv__container',
                        hover: 'iv__container--active',
                        fallback: '.iv__upload__dnd-not-supported',
                    },
                },
                onComplete() {
                    myself.element.find('.iv__upload').slideUp().addClass('iv__upload--hidden');
                    myself.load();
                    myself.isBusy = false;
                },
                onDrop(evt, ui) {
                    if (ui.files.length && myself.template.upload.crop) {
                        myself.isBusy = true;
                        myself.element.find('.iv__upload').slideDown().removeClass('iv__upload--hidden');
                        const { files } = ui;
                        const cropOptionsGroups = myself.template.upload.crop;
                        const cropOptionsGroupsKey = Object.keys(cropOptionsGroups);
                        var cropWindow = function (index, subindex) {
                            const file = files[index];
                            const cropKey = cropOptionsGroupsKey[subindex];
                            const cropOptions = cropOptionsGroups[cropKey];
                            const cropableFormats = ['image/png', 'image/jpeg', 'image/gif', 'image/webp'];
                            console.log(file.type);

                            if (!cropableFormats.includes(file.type) || myself.template.upload.crop.length == 0) {
                                setTimeout(function() {
                                    // Boucler dans les images
                                    if (index < files.length - 1) {
                                        console.log('next image');
                                        cropWindow(index + 1, 0);
                                    }
                                    // Finir le processus
                                    else {
                                        console.log('end process');
                                        $(myself.element).fileapi('upload');
                                    }
                                }, 100)
                            }
                            else if (!FileAPI.support.transform) {
                                alert('Your browser does not support transform :(');
                            } else if (file) {
                                var currentWindow = $.window({
                                    id: 'imageBrowserWindow',
                                    title: 'Recadrage des images - ' + ((cropOptions.name)?cropOptions.name:cropKey) + ' (' + (index + 1) + ' de ' + files.length + ')',
                                    content: `<div id="popup-jcrop" class="popup-jcrop" style="display: none;">
                                        <div class="popup__body"><div class="js-img"></div></div>
                                        <div style="margin: 0 0 5px; text-align: center;">
                                        <div class="toolbar--form window__toolbar--bottom">
                                        <button class="btn-cancel btn-type-caution btn action--danger">Annuler</button>
                                        <button class="btn action--success action--submit js-upload btn_browse btn_browse_small">Valider</button>
                                        </div>
                                        </div>
                                        </div>`,
                                    maxWidth: -1, // the minimum width, if -1 means no checking
                                    maxHeight: -1,		 // the minimum height, if -1 means no checking
                                    showFooter: false,
                                    maximizable: false,
                                    closable: true,
                                    showModal: true,
                                    width: '98%',
                                    height: '98%',
                                    checkBoundary: true,
                                    withinBrowserWindow: false,
                                    onExit() {
                                        if (currentWindow.step != 'next') {
                                            myself.element.find('.iv__upload').slideUp().addClass('iv__upload--hidden');
                                        }
                                    },
                                    onShow() {
                                        const currentFrame = this.content;
                                        currentFrame.find('.js-upload').click(() => {
                                            currentWindow.step = 'next'
                                            currentWindow.close();
                                            // Boucler dans les variantes
                                            if (subindex < cropOptionsGroupsKey.length - 1) {
                                                console.log('next variation');
                                                cropWindow(index, subindex + 1);
                                            }
                                            else {
                                                // Boucler dans les images
                                                if (index < files.length - 1) {
                                                    console.log('next image');
                                                    cropWindow(index + 1, 0);
                                                }
                                                // Finir le processus
                                                else {
                                                    console.log('end process');
                                                    $(myself.element).fileapi('upload');
                                                }
                                            }
                                        });
                                        currentFrame.find('.btn-cancel').click(() => {
                                            if (index > 0) {
                                                Swal.fire({
                                                    title: 'Annuler l\'envoi des images ?',
                                                    text: 'Voulez-vous vraiment interompre l\'envoie des images ? Le découpage de toutes les images précédentes ne sera pas mémorisé et tous les transferts en cours seront annulé.',
                                                    type: 'warning',
                                                    showCancelButton: true,
                                                    confirmButtonColor: '#3085d6',
                                                    cancelButtonColor: '#d33',
                                                    confirmButtonText: 'Oui',
                                                    cancelButtonText: 'Non',
                                                }).then((result) => {
                                                    if (result.value) {
                                                        currentWindow.close();
                                                        $(myself.element).fileapi('clear');
                                                    }
                                                })
                                            } else {
                                                currentWindow.close();
                                                $(myself.element).fileapi('clear');
                                            }
                                        });
                                        $(currentFrame).find('.js-img').cropper({
                                            boxWidth: $(currentFrame).width(),
                                            boxHeight: $(currentFrame).height(),
                                            file,
                                            aspectRatio: (cropOptions.ratio) ? cropOptions.ratio : null,
                                            trueSize: true,
                                            setSelect: [0, 2000, 2000, 0],
                                            onSelect(coords) {
                                                if (myself.template.upload.crop.client) {
                                                    $(myself.element).fileapi('crop', file, coords);
                                                } else {
                                                    if (!file.data) file.data = {};
                                                    if (!file.data.crop) file.data.crop = {};
                                                    file.data.crop[cropKey] = {};
                                                    for (const key in coords) {
                                                        if (coords.hasOwnProperty(key)) {
                                                            file.data.crop[cropKey][key] = coords[key];
                                                            // $(myself.element).fileapi('data')[key] = coords[key];
                                                        }
                                                    }
                                                }
                                            },
                                        });
                                    },
                                });
                            }
                        }
                        cropWindow(0, 0);
                    }
                },
            });
        }
    };


IconsView.prototype.renderIconsAreas = function (node) {
        const myself = this;
        if (this.tabMode == 'first') {
            if (node) {
                this.dataNode = node;
            } else {
                this.dataNode = node = this.data;
            }

            // Loop for each icons
            $.each(node, (index, iconData) => {
                if (iconData) {
                    if (iconData.special == 'root' || iconData.special == 'parent') return true;
                    const data = iconData;
                    const tabName = formatFilename(data.label);
                    const tabContain = myself.element.find('.tab-' + tabName).find('> .iv__container');
                    if (tabContain.length) {
                        myself.renderIconsArea(data.childs, tabContain, false);
                    }
                }
            });

            myself.reloadInput = true;
        } else if (this.tabMode == 'defined') {
            if (node) {
                this.dataNode = node;
            } else {
                this.dataNode = node = this.data;
            }

            // Find missing groups
            const detectedGroups = {};
            $.each(this.dataNode, (index, item) => {
                detectedGroups[item.group] = 1;
            });

            $.each(this.options.features.tab, (index, iconData) => {
                if (iconData) {
                    detectedGroups[iconData.id] = 0;

                    const filteredNode = [];
                    $.each(node, (index, item) => {
                        if (item.group == iconData.id || !item.group) {
                            filteredNode.push(item);
                        }
                    });

                    const tabContain = myself.element.find('.tab-' + iconData.id).find('.iv__container');
                    if (tabContain.length) {
                        myself.renderIconsArea(filteredNode, tabContain);
                    }
                }
            });
        } else {
            this.renderIconsArea(this.dataNode, myself.element.find('.view'));
        }
    }


IconsView.prototype.renderIconsArea = function (node, container, subdir, path) {
        const myself = this;

        if (!container.length) container = myself.container;
        container.find('.iv__item').remove();

        // Loop for each icons
        if (node) {
            this.renderIcons(node, container, subdir, path);

            myself.onUnload($('#sortHelper'));
            $('#sortHelper').html('');

            // Sortable behavior
            if (this.options.features.sortable && (myself.view == 'tree' || myself.view == 'blocks')) {
                this.element.addClass('iv--feature-sortable');
                container.nestedSortable({
                    forcePlaceholderSize: true,
                    listType: 'ol',
                    helper: 'clone',
                    items: '.iv__item:not(.iv__item--special-parent)',
                    toleranceElement: '> div',
                    opacity: 0.6,
                    placeholder: 'placeholder',
                    revert: 250,
                    tabSize: 25,
                    tolerance: 'pointer',
                    appendTo: '#sortHelper',
                    handle: '.iv__item__image',
                    isTree: true,
                    delay: 150,
                    distance: 5,
                    expandOnHover: 700,
                    startCollapsed: true,
                    handle: '.iv__item__preframe',
                    branchClass: 'iv__item--branch',
                    collapsedClass: 'iv__item--collapsed',
                    disableNestingClass: 'iv__item--nonesting',
                    errorClass: 'iv__item--error',
                    expandedClass: 'iv__item--expanded',
                    hoveringClass: 'iv__item--hovering',
                    leafClass: 'iv__item--leaf',
                    disabledClass: 'iv__item--disabled',
                    start(e, ui) {
                        const grid = $(this).closest('.iconGrid');

                        // Selection management: if dragging an unselected item, select only it
                        if (!ui.item.hasClass('iv__item--selected')) {
                            grid.find('.iv__item--selected').removeClass('iv__item--selected');
                            ui.item.addClass('iv__item--selected');
                            myself.selection = [];
                            myself.addSelectionFromIcon(ui.item);
                            myself.changeSelection(ui.item);
                        }

                        ui.placeholder.height(ui.item.height());
                        ui.placeholder.width(ui.item.width());
                    },
                    update(event, ui) {
                        const myself = $(this).closest('.iconGrid').data('plugin');
                        const grid = $(this).closest('.iconGrid');
                        const selectedItems = grid.find('.iv__item--selected');

                        // Move all selected items together in the DOM
                        const others = selectedItems.not(ui.item);
                        if (others.length > 0) {
                            ui.item.after(others);
                        }

                        myself.submitOrder();

                        // basics manipulations
                        const dropped = ui.item;
                        let target = ui.item.parent().closest('.iv__item');

                        // try with tab
                        if (!target.length) {
                            const currentTab = ui.item.parent().closest('.tab-content');
                            if (currentTab) {
                                target = currentTab.data('item');
                            }
                        }

                        if (!target || !target.length) {
                            target = $(this).find('.iv__item--special-parent');
                        }

                        // find
                        const dropProperties = target.data('droppable-' + $(dropped).data('type'));

                        // submit parent change for all selected items
                        myself.submitParent(selectedItems.toArray(), target, dropProperties);
                    },
                    stop(event, ui) {
                        const grid = $(this).closest('.iconGrid');
                        const selectedItems = grid.find('.iv__item--selected');

                        // Fix display block issue
                        ui.item.css('display', '');
                        selectedItems.css('display', '');
                    },
                    change() {
                    },
                    scrollSpeed: 8,
                    scroll: true,
                    cursorAt: { left: 58, top: -10 },
                });
            } else if (this.options.features.sortable) {
                this.element.addClass('iv--feature-sortable');
                container.sortable({
                    delay: 150,
                    items: '.iv__item:not(.iv__item--special-parent)',
                    create(event, ui) {
                    },
                    update(event, ui) {
                        const myself = $(this).closest('.iconGrid').data('plugin');
                        const grid = $(this).closest('.iconGrid');
                        const selectedItems = grid.find('.iv__item--selected');

                        // Move all selected items together in the DOM
                        const others = selectedItems.not(ui.item);
                        if (others.length > 0) {
                            ui.item.after(others);
                        }

                        myself.submitOrder();

                        // répliquer le changement d'ordre et de parent sur les nodes pour chaque item
                        selectedItems.each(function() {
                            const item = $(this);
                            const itemData = item.data('data');
                            let oldParent = item.data('parent');
                            if (oldParent && oldParent.childs) {
                                const index = oldParent.childs.findIndex(c => c.id === itemData.id && c.type === itemData.type);
                                if (index !== -1) oldParent.childs.splice(index, 1);
                                oldParent.childs.splice(item.index(), 0, itemData);
                            }
                        });
                    },
                    start(event, ui) {
                        const grid = $(this).closest('.iconGrid');

                        // Selection management: if dragging an unselected item, select only it
                        if (!ui.item.hasClass('iv__item--selected')) {
                            grid.find('.iv__item--selected').removeClass('iv__item--selected');
                            ui.item.addClass('iv__item--selected');
                            myself.selection = [];
                            myself.addSelectionFromIcon(ui.item);
                            myself.changeSelection(ui.item);
                        }

                        ui.placeholder.addClass('iv__placeholder');
                        ui.placeholder.height(ui.item.height());
                        ui.placeholder.width(ui.item.width());
                        ui.item.addClass('iv__item--moving');
                        grid.find('.iv__item--selected').not('.iv__placeholder').addClass('iv__item--moving');
                        myself.setCursor('sort');
                    },
                    stop(event, ui) {
                        const grid = $(this).closest('.iconGrid');
                        const selectedItems = grid.find('.iv__item--selected');

                        $(this).height('auto')
                        ui.item.removeClass('iv__item--moving');
                        grid.find('.iv__item--moving').removeClass('iv__item--moving');

                        // Fix display block issue
                        ui.item.css('display', '');
                        selectedItems.css('display', '');

                        myself.setCursor('');
                    },
                    helper: 'clone',
                    tolerance: 'intersect',
                    appendTo: '#sortHelper',
                    handle: '.iv__item__image',
                    distance: 5,
                    revert: 0,
                    scrollSpeed: 8,
                    scrollSensitivity: 20,
                    scroll: true,
                    cursorAt: { left: 58, top: -10 },
                });
            } else if (this.options.features.droppable) {
                this.element.removeClass('iv--feature-sortable');

                let draggableContainer = container.find('.iv__item').not('.iv__item--special-parent');

                /*
                draggableContainer.find('.iv__item__image').mousedown(function() {
                    let item = $(this).closest('.iv__item');
                    let ref = item.attr('class').match(/iv__item--ref-(\d+)/)[1];
                    myself.element.find('.iv__item--ref-match').removeClass('iv__item--ref-match');
                    if (ref) {
                        myself.element.find('.iv__item--ref-'+ref).addClass('iv__item--ref-match');
                    }
                });
                */

                draggableContainer.draggable({
                    delay: 150,
                    helper: 'clone',
                    appendTo: '#sortHelper',
                    handle: '.iv__item__image',
                    distance: 5,
                    scrollSpeed: 8,
                    scroll: true,
                    revert: 0,
                    revertDuration: 200,
                    cursorAt: { left: 58, top: -10 },
                    start(event, ui) {
                        const grid = $(this).closest('.iconGrid');
                        const item = $(this);

                        // Selection management
                        if (!item.hasClass('iv__item--selected')) {
                            grid.find('.iv__item--selected').removeClass('iv__item--selected');
                            item.addClass('iv__item--selected');
                            myself.selection = [];
                            myself.addSelectionFromIcon(item);
                            myself.changeSelection(item);
                        }

                        ui.helper.find('.iv__item__icon').css('background-image', 'url(' + ui.helper.find('.iv__item__icon').data('hd') + ')');
                        if (ui.item) ui.item.addClass('iv__item--moving');
                        else if (ui.helper.context) $(ui.helper.context).addClass('iv__item--moving');
                        grid.find('.iv__item--selected').not('.iv__placeholder').addClass('iv__item--moving');
                        myself.setCursor('sort');
                    },
                    stop(event, ui) {
                        const grid = $(this).closest('.iconGrid');
                        $(this).height('auto')
                        if (ui.item) ui.item.removeClass('iv__item--moving');
                        else if (ui.helper.context) $(ui.helper.context).removeClass('iv__item--moving');
                        grid.find('.iv__item--moving').removeClass('iv__item--moving');
                        myself.setCursor('drop');
                    },
                });
            } else {
                this.element.removeClass('iv--feature-sortable');
            }

            // Load data value
            container.find('.iv__item__input input, .iv__item__input select, .iv__item__input textarea').each(function (index) {
                const current = $(this).closest('.iv__item');
                const data = current.data('data');
                const inputContainer = $(this).closest('.iv__item__input');
                const currentValue = data.data[inputContainer.data('property')];
                if (currentValue) {
                    $(this).val(currentValue);
                }
            });
            // Enable input field modification
            container.find('.iv__item__input input, .iv__item__input select, .iv__item__input textarea').change(function () {
                const current = $(this).closest('.iv__item');
                const data = current.data('data');
                const inputContainer = $(this).closest('.iv__item__input');
                const request = {
                    id: data.id,
                }
                const property = inputContainer.data('property');
                request[property] = $(this).val();
                let compA = data.data[property];
                let compB = request[property];
                if (compA === '' || compA === undefined) compA = null;
                if (compB === '' || compB === undefined) compB = null;
                let propertyHasChanged = compA != compB;
                data.data[property] = $(this).val();

                if ($(this).attr('type') == 'checkbox' && !$(this).is(':checked')) {
                    request[property] = 0;
                    data.data[property] = 0;
                    propertyHasChanged = true;
                }

                if (propertyHasChanged) {
                    myself.submitChange(data, request);
                    if (myself.events.edit) myself.events.edit();
                }
            });

            // Enable EXPEND / Collapse feature
            container.find('.iv__item__expend').click(function (e) {
                const current = $(this).closest('.iv__item');
                if (current.hasClass('iv__item--expanded')) {
                    myself.treeExpend(current, false);

                    if (e.ctrlKey) {
                        var expendChilds = current.find('.iv__item');
                        expendChilds.each(function () {
                            myself.treeExpend($(this), false);
                        });
                    }
                } else {
                    myself.treeExpend(current, true);

                    if (e.ctrlKey) {
                        var expendChilds = current.find('.iv__item');
                        expendChilds.each(function () {
                            myself.treeExpend($(this), true);
                        });
                    }
                }
            });


            // click on iconGrid BG
            if (this.options.features.bgUnselect && !this.options.features.lockSelection) {
                container.click(function (event) {
                    if (!event.ctrlKey && !event.shiftKey) {
                        const grid = $(this).closest('.iconGrid');
                        grid.data('plugin').selection = [];
                        $(this).find('.iv__item').removeClass('iv__item--selected');
                        grid.data('plugin').changeSelection();
                    }
                }).children().click((e) => false);
            }

            // Final refresh
            myself.changeSelection();
            myself.sort();
            myself.renderDroppable(container);
        }

        if (!myself.dataNodeParent.loaded) {
            myself.lazyLoad(myself.dataNodeParent);
        }
    };


IconsView.prototype.treeExpend = function (current, status) {
        const myself = this;
        myself.dataExpand[current.data('type') + '-' + current.data('id')] = status;

        if (status) {
            current.find('> .iv__item__tree').slideDown(200);
            current.addClass('iv__item--expanded');
        } else {
            current.find('> .iv__item__tree').slideUp(200);
            current.removeClass('iv__item--expanded');
        }
    }


IconsView.prototype.renderIcons = function (node, container, subdir, path) {
        const myself = this;
        if (!container) container = myself.container;

        myself.element.addClass('iv--updated');

        $(container).addClass('iv__container');

        if (!path) path = [];

        // Loop for each icons
        let renderCount = 0;
        let pathChild;
        $.each(node, (index, iconData) => {
            pathChild = path.slice(0);
            pathChild.push(index - 1);

            if (myself.renderIcon(iconData, container, subdir, pathChild) && !iconData.special) {
                renderCount++;
            }
        });

        if (!renderCount && (!subdir || (myself.view != 'tree' && myself.view != 'blocks'))) {
            pathChild = path.slice(0);
            myself.renderIcon(myself.options.sample.none, container, subdir, pathChild);
        }
        if (myself.view == 'tree' || myself.view == 'blocks') {
            container.addClass('iv__item__tree');
        }

        myself.resize();

        setTimeout(() => {
            myself.element.removeClass('iv--updated');
        }, 1000)

        return container.find('> .iv__item').length;
    };


IconsView.prototype.renderIcon = function (iconData, container, subdir, path) {
        const myself = this;

        if (iconData && myself.filter(iconData)) {
            let columnData, currentIconChilds;

            // todo fix parent
            if (iconData.special == 'parent') {
                if (subdir || !this.path.length)
                return null;
            }

            let data = iconData;
            data = this.remapData(data);
            if (!data.actions) data.actions = myself.options.actions;
            if (!data.default) data.default = myself.options.default;
            let currentIconReact;
            let currentIcon;
            let currentType = (iconData.type) ? iconData.type : 'item';
            if (typeof currentType == 'string') currentType = [currentType];
            let currentClass = (iconData.class) ? iconData.class : [];
            if (typeof currentClass === 'object') currentClass = currentClass.join(' ');
            const currentRandomId = parseInt(Math.random() * 1000000);
            let currentClassAll = [
                'iv__item',
                'iv__item--' + data.id,
                'iv__item--' + currentRandomId,
                currentClass
            ];
            $.each(currentType, function() {
                currentClassAll.push('iv__item--type-' + this);
            })
            if (iconData.ref) currentClassAll.push('iv__item--ref-' + iconData.ref);
            if (data.special) currentClassAll.push('iv__item--special-' + data.special);
            myself.viewThumbsProportions = 1;
            myself.viewThumbsHeight = 64;
            myself.viewThumbsWidth = 64;

            // selection test
            $.each(myself.selection, (selectionIndex, selectionItem) => {
                if (selectionItem.id == data.id && selectionItem.type == data.type) {
                    currentClassAll.push('iv__item--selected');
                }
            });

            // droppable test
            let enableDroppable = false;
            if (this.options.features.droppable) {
                $.each(this.options.features.droppable, function (indexDrop, columnDrop) {
                    if (this.target.indexOf(data.type) > -1) {
                        enableDroppable = true;
                    }
                })
            }
            if (!enableDroppable) currentClassAll.push('iv__item--nonesting');

            // prepare classes Array
            currentClassAll = currentClassAll.join(' ');

            // VIEWS
            switch (myself.view) {
            // Table VIEW
            case 'table':
                myself.viewThumbsHeight = 48;
                myself.viewThumbsWidth = 48;
                if (myself.template && myself.template.view && myself.template.view.table) {
                    myself.viewThumbsHeight = myself.template.view.table.size;
                    myself.viewThumbsWidth = myself.template.view.table.size;
                    myself.viewItemWidthRatio = 0;
                    myself.viewItemThumbsMode = false;
                }
                if (data.type == 'root') return null;
                container.find('> .iv__item') // lines
                var columns = new Array();
                if (myself.template && myself.template.view && myself.template.view.table) {
                    $.each(myself.template.view.table, (indexView, column) => {
                        columnData = '<td>&nbsp;</td>';
                        if (column.type == 'action') {
                            if (data.actions && !data.special) {
                                const action = data.actions[column.name];
                                if (action) {
                                    const buttonIcon = myself.renderIconImage('small', action.icon);
                                    columnData = '<td class="iv__item__action">'
                                            + '<button class="action--default action" title="' + action.label + '" data-action="' + column.name + '">' + buttonIcon + '</button>'
                                            + '</td>';
                                }
                            }
                        } else if (column.type == 'input') {
                            myself.reloadInput = true;
                            if (data.input) {
                                const inputProps = data.input[column.name];
                                const input = (Array.isArray(inputProps))?inputProps[0]:inputProps;
                                if (input) {
                                    columnData = '<td class="iv__item__input" data-property="' + column.name + '">'
                                            + input
                                            + '</td>';
                                }
                                if (Array.isArray(inputProps) && inputProps[1]) {
                                    setTimeout(function() {
                                        eval(inputProps[1]);
                                    }, 10)
                                }
                            }
                        } else if (column.type == 'label') {
                            columnData = '<td class="iv__item__name">' + data.label + '</td>';
                        } else if (column.type == 'icon') {
                            const currentSize = (column.size && isNumeric(column.size)) ? column.size : 24;
                            columnData = '<td class="iv__item__data"><div class="iv__item__image size-' + currentSize + '" style="width: ' + currentSize + 'px; height: ' + currentSize + 'px;">' + myself.renderIconImage(currentSize, (column.name) ? data[column.name] : data.icon, data, 'img') + '</div></td>';
                        } else if (data.data && data.data[column.name]) {
                            columnData = '<td class="iv__item__data">' + data.data[column.name] + '</td>';
                        }
                        columns.push(columnData);
                    });
                }
                var code = '<tr class="' + currentClassAll + '">'
                        + columns.join('')
                        + '</tr>';
                currentIcon = $(code);
                currentIconReact = currentIcon.find('td.iv__item__image, td.iv__item__data, td.iv__item__name');
                break;

                // Tree VIEW
            case 'tree':
            case 'blocks':
                // front lines
                var codeSubtext = [];
                if (data && myself.template && myself.template.view && myself.template.view.mosaic) {
                    $.each(myself.template.view.mosaic, (indexView, view) => {
                        if (data[view]) {
                            codeSubtext.push(myself.renderSubdata(data[view], null, null, data));
                        }
                    });
                }
                var code = '<li class="' + currentClassAll + '"><div class="iv__item__preframe"><div class="iv__item__expend"></div><div class="iv__item__frame iv__item__main"><span class="iv__item__link"><span class="iv__item__image">' + myself.renderIconImage('small', data.icon, data, 'img') + '</span> '
                        + '<label class="iv__item__label">'
                        + '<span class="iv__item__name titre">' + data.label + '</span>'
                        + '</label></span></div></div></li>';
                currentIcon = $(code);
                currentIconChilds = $('<ol class="iv__item__childs iv__item__tree"></ol>');
                currentIcon.append(currentIconChilds);
                currentIconReact = currentIcon.find(' > div > .iv__item__main').first();
                myself.viewThumbsHeight = 24;
                myself.viewThumbsWidth = 24;
                myself.viewItemWidthRatio = 0;
                myself.viewItemThumbsMode = false;
                break;

                // Thumbnails VIEW
            case 'thumbnails':
            case 'slideshow':
                if (data.type == 'root') return true;
                // front lines
                var codeSubtext = [];
                if (data && myself.template && myself.template.view && myself.template.view.mosaic) {
                    $.each(myself.template.view.mosaic, (indexView, view) => {
                        if (data[view]) {
                            codeSubtext.push(myself.renderSubdata(data[view], null, null, data));
                        }
                    });
                }

                var thumbsWidth = 256;
                var thumbsHeight = 256;
                if (myself.view == 'slideshow') {
                    thumbsWidth = 128;
                    thumbsHeight = 128;
                }
                if (myself.dataNodeParent.thumbs) {
                    var thumbsWidth = myself.dataNodeParent.thumbs.width;
                    var thumbsHeight = myself.dataNodeParent.thumbs.height;
                } else if (myself.template.view.thumbnails && myself.template.view.thumbnails.width) {
                    var thumbsWidth = myself.template.view.thumbnails.width;
                    var thumbsHeight = myself.template.view.thumbnails.height;
                }
                myself.viewThumbsWidth = thumbsWidth;
                myself.viewThumbsHeight = thumbsHeight;
                myself.viewThumbsProportions = thumbsWidth / thumbsHeight;
                myself.viewItemWidthRatio = thumbsWidth / thumbsHeight;
                myself.viewItemThumbsMode = true;
                myself.viewItemWidthMin = 48;
                myself.viewItemWidthMax = 512;

                var columns = [];
                if (myself.template && myself.template.view && myself.template.view.thumbnails) {
                    $.each(myself.template.view.thumbnails, (indexView, column) => {
                        if (column.type == 'action') {
                            if (data.actions) {
                                const action = data.actions[column.name];
                                if (action) {
                                    const buttonIcon = myself.renderIconImage('small', action.icon);
                                    const columnData = '<div class="iv__item__action button-icon">'
                                            + '<button class="action--default action" title="' + action.label + '" data-action="' + column.name + '">' + buttonIcon + '</button>'
                                            + '</div>';

                                    columns.push(columnData);
                                }
                            }
                        }
                    });
                }

                var previewCode = '';
                if (data.html && !data.thumb) {
                    previewCode = '<div class="iv__item__image"><div class="iv__item__html iv__item__html" style="' + ((myself.template.view.thumbnails && (myself.template.view.thumbnails.margin || myself.template.view.thumbnails.margin === 0)) ? 'margin:' + myself.template.view.thumbnails.margin + ';' : '') + '">' + data.html + '</div></div>';
                } else {
                    previewCode = '<span class="iv__item__image" style="width:' + thumbsWidth + 'px; height:' + thumbsHeight + 'px; ' + ((data.color) ? 'background-color: ' + data.color + ';' : '') + '">';

                    if (data.thumb) previewCode += myself.renderIconImage('thumb', data.thumb, data, 'thumb');
                    else if (data.logo) previewCode += myself.renderIconImage('logo', data.logo, data, 'logo');
                    else previewCode += myself.renderIconImage('hd', data.icon, data, 'img');
                    previewCode += '</span> ';
                }

                var code = '<div class="' + currentClassAll + '"><div class="iv__item__frame iv__item__frame" style="max-width:' + thumbsWidth + 'px;"><span class="iv__item__link">'
                        + previewCode
                        + '<label class="iv__item__label">'
                        + '<span class="iv__item__name titre">' + ((data.label) ? data.label : '&nbsp;') + '</span>'
                        + ((codeSubtext.length > 0) ? '<span class="iv__item__data infos">' + codeSubtext.join('') + '</span>' : '')
                        + '</label></span></div>' + ((columns) ? '<div class="iv__item__actions">' + columns.join('') + '</div>' : '') + '</div>';

                currentIcon = $(code);
                currentIconReact = currentIcon.find('.iv__item__image, .iv__item__name');
                break;

                // Summary VIEW
            case 'summary':
                myself.viewThumbsHeight = 112;
                myself.viewThumbsWidth = 112;
                myself.viewItemWidthRatio = 4;
                myself.viewItemWidthMin = 300;
                myself.viewItemWidthMax = 800;
                myself.viewItemThumbsMode = true;
                if (data.type == 'root') return true;
                // front lines
                var codeSubtext = [];
                var codeActions = [];
                if (data && myself.template && myself.template.view && myself.template.view.summary) {
                    $.each(myself.template.view.summary, (indexView, column) => {
                        if (column.type == 'action') {
                            if (data.actions && !data.special) {
                                const action = data.actions[column.name];
                                if (action) {
                                    const buttonIcon = myself.renderIconImage('small', action.icon);
                                    columnData = '<span class="iv__item__action">'
                                            + '<button class="action--default action" title="' + action.label + '" data-action="' + column.name + '">' + buttonIcon + '</button>'
                                            + '</span>';
                                            codeActions.push(columnData);
                                }
                            }
                        }
                        else {
                            let codeStart = '';
                            let codeEnd = '';
                            if (typeof column === 'object') {
                                if (column.tag) {
                                    codeStart = '<' + column.tag + '>';
                                    codeEnd = '</' + column.tag + '>';
                                }
                                column = column.data;
                            }
                            if (data.data && data.data[column]) {
                                codeSubtext.push(myself.renderSubdata(data.data[column], codeStart, codeEnd, data));
                            }
                        }
                    });
                }
                else if (myself.template && myself.template.view && myself.template.view.table) {
                    $.each(myself.template.view.table, (indexView, column) => {
                        columnData = '';
                        if (column.type == 'action') {
                            if (data.actions && !data.special) {
                                const action = data.actions[column.name];
                                if (action) {
                                    const buttonIcon = myself.renderIconImage('small', action.icon);
                                    columnData = '<span class="iv__item__action">'
                                            + '<button class="action--default action" title="' + action.label + '" data-action="' + column.name + '">' + buttonIcon + '</button>'
                                            + '</span>';
                                    codeActions.push(columnData);
                                }
                            }
                        } else if (column.type == 'input') {
                            myself.reloadInput = true;
                            if (data.input) {
                                const input = data.input[column.name];
                                if (input) {
                                    columnData = '<div class="iv__item__input" data-property="' + column.name + '">'
                                            + input
                                            + '</div>';
                                }
                                codeSubtext.push(columnData);
                            }
                        } else if (data.data && data.data[column.name]) {
                            columnData = '<div class="iv__item__detail">' + data.data[column.name] + '</div>';
                            codeSubtext.push(columnData);
                        }
                    });
                }

                var thumbsWidth = 256;
                var thumbsHeight = 256;
                if (myself.dataNodeParent.thumbs) {
                    var thumbsWidth = myself.dataNodeParent.thumbs.width;
                    var thumbsHeight = myself.dataNodeParent.thumbs.height;
                } else if (myself.template.view.thumbnails && myself.template.view.thumbnails.width) {
                    var thumbsWidth = myself.template.view.thumbnails.width;
                    var thumbsHeight = myself.template.view.thumbnails.height;
                }

                var code = '<div class="' + currentClassAll + '"><div class="iv__item__frame"><span class="iv__item__link"><span class="iv__item__wrap"><span class="iv__item__image" style="width:' + thumbsWidth + 'px; height:' + thumbsHeight + 'px;">' + myself.renderIconImage('hd', data.icon, data, 'img') + `</span></span>
                        <label class="iv__item__label" style="width:` + thumbsWidth + 'px; max-height:' + thumbsWidth + `px;">
                        <span class="iv__item__name titre">` + data.label + `</span>
                        ` + ((codeSubtext.length > 0) ? '<span class="iv__item__data infos">' + codeSubtext.join('') + '</span>' : '') + `
                        ` + ((codeActions.length > 0) ? '<span class="iv__item__actions">' + codeActions.join('') + '</span>' : '') + `
                        </label></span></div></div>`;
                currentIcon = $(code);
                currentIconReact = currentIcon.find('.iv__item__image');
                break;

                // Calendar VIEW
            case 'calendar':
            case 'calendar-week':
            case 'calendar-day':
                if (data.type == 'root') return true;
                myself.viewThumbsHeight = 24;
                myself.viewThumbsWidth = 24;
                myself.viewItemWidthRatio = 3;
                myself.viewItemThumbsMode = false;

                // Build icon DOM
                var codeSubtext = [];
                var calendarFields = (myself.template && myself.template.view && myself.template.view.calendar && myself.template.view.calendar.add)
                    ? myself.template.view.calendar.add
                    : (myself.template && myself.template.view && myself.template.view.mosaic ? myself.template.view.mosaic : null);
                if (data && calendarFields) {
                    $.each(calendarFields, (indexView, view) => {
                        var rawVal = (data.data && data.data[view]) ? data.data[view] : data[view];
                        var subdata = myself.renderSubdata(rawVal, null, null, data);
                        if (subdata) {
                            codeSubtext.push(subdata);
                        }
                    });
                }
                var code = '<div class="' + currentClassAll + '"><div class="iv__item__frame"><span class="iv__item__link"><span class="iv__item__image">' + myself.renderIconImage(24, data.icon, data, 'img') + '</span> '
                        + '<label class="iv__item__label">'
                        + '<span class="iv__item__name titre">' + data.label + '</span>'
                        + ((codeSubtext.length > 0) ? '<span class="iv__item__data infos">' + codeSubtext.join('') + '</span>' : '')
                        + '</label></span></div></div>';
                currentIcon = $(code);

                // Attach data to icon element
                $.each(data, (propertie, value) => {
                    if (typeof propertie === 'string') {
                        currentIcon.data(propertie, value);
                    }
                });
                currentIcon.data('type', currentType);
                currentIcon.data('plugin', myself);
                currentIcon.data('data', data);
                currentIcon.data('path', path);

                // Add event to FullCalendar
                if (myself.calendar) {
                    let eventStart, eventEnd, allDay = true;

                    // Helper: extract date string from various formats
                    const extractDate = function(val) {
                        if (!val) return null;
                        if (typeof val === 'string') return val;
                        if (val instanceof Date) return val.toISOString();
                        if (typeof val === 'object' && val.date) return val.date; // PHP DateTime {date:"...", timezone:"..."}
                        return null;
                    };

                    // 1) Try config fields
                    const dateFields = myself.getDateFields(data.type);
                    let rawDate = data.date;

                    // Parse the found date value
                    if (rawDate) {
                        if (Array.isArray(rawDate) && rawDate.length >= 2) {
                            eventStart = extractDate(rawDate[0]);
                            eventEnd = extractDate(rawDate[1]);
                        } else if (Array.isArray(rawDate) && rawDate.length === 1) {
                            eventStart = extractDate(rawDate[0]);
                        } else {
                            eventStart = extractDate(rawDate);
                        }
                    }

                    // 3) Handle timeless items (sidebar) vs timed items (calendar)
                    if (eventStart) {
                        if (typeof eventStart === 'string') eventStart = eventStart.replace(' ', 'T');
                        if (eventEnd && typeof eventEnd === 'string') eventEnd = eventEnd.replace(' ', 'T');

                        const tStart = eventStart.includes('T') ? eventStart.split('T')[1] : '';
                        const isZeroStart = !tStart || tStart.startsWith('00:00');

                        if (!eventEnd) {
                            if (isZeroStart) {
                                allDay = true;
                            } else {
                                allDay = false;
                                let d = new Date(eventStart);
                                if (isNaN(d.getTime())) {
                                    // Fallback if parsing fails
                                    allDay = true;
                                } else {
                                    d.setMinutes(d.getMinutes() + 30);
                                    const pad = n => n < 10 ? '0' + n : n;
                                    eventEnd = d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + 'T' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':00';
                                }
                            }
                        } else {
                            allDay = false; // Has both dates, assume timed initially

                            const tEnd = eventEnd.includes('T') ? eventEnd.split('T')[1] : '';
                            const isZeroEnd = !tEnd || tEnd.startsWith('00:00');

                            if (isZeroStart && isZeroEnd) {
                                allDay = true;
                            }
                        }

                        console.debug('[IconsView Calendar] addEvent:', data.label, '| start:', eventStart, '| raw:', rawDate);

                        myself.calendar.addEvent({
                            id: data.id,
                            title: data.label || '',
                            start: eventStart,
                            end: eventEnd || undefined,
                            allDay: allDay,
                            color: data.color || undefined,
                            editable: !!myself.getDateFields(data.type),
                            extendedProps: {
                                iconElement: currentIcon,
                                itemData: data,
                            }
                        });

                        // Return early: skip generic container.append and click handlers
                        if (myself.items !== undefined) {
                            myself.items.push(currentIcon);
                        }
                        return currentIcon;
                    } else if (myself.sidebarContainer) {
                        // NO DATE -> SIDEBAR
                        container = myself.sidebarContainer;
                    } else {
                        // Fallback: place on today if no date and no sidebar
                        eventStart = new Date().toISOString().split('T')[0];
                        myself.calendar.addEvent({
                            id: data.id,
                            title: data.label || '',
                            start: eventStart,
                            allDay: true,
                            editable: !!myself.getDateFields(data.type),
                            extendedProps: {
                                iconElement: currentIcon,
                                itemData: data,
                            }
                        });
                        if (myself.items !== undefined) {
                            myself.items.push(currentIcon);
                        }
                        return currentIcon;
                    }
                }

                // Build context menu data (same logic as generic path)
                let menuItems = [];
                if (data.actions) {
                    $.each(data.actions, (propertie, value) => {
                        if (!value) return true;
                        let smallCurrentIcon = value.icon;
                        if (typeof smallCurrentIcon === 'object') smallCurrentIcon = smallCurrentIcon.small;
                        menuItems.push({
                            name: value.label,
                            icon: smallCurrentIcon,
                            callback(icon) {
                                const plugin = icon.data('plugin');
                                const grid = icon.closest('.iconGrid');
                                if (icon.hasClass('iv__item--selected') && grid.find('.iv__item--selected').length > 1) {
                                    plugin.action(icon.data('actions')[propertie], grid, propertie);
                                } else {
                                    plugin.action(icon.data('actions')[propertie], icon, propertie);
                                }
                            },
                        });
                    });
                    if (menuItems.length) {
                        currentIcon.data('menu', menuItems);
                    }
                }

                // If sidebar item, break to let generic container.append run
                if (container === myself.sidebarContainer) break;

                // Otherwise return early
                if (myself.items !== undefined) {
                    myself.items.push(currentIcon);
                }
                return currentIcon;

                // Mosaic VIEW
            default:
                myself.viewItemThumbsMode = false;
                if (myself.view == 'list') {
                    myself.viewThumbsHeight = 24;
                    myself.viewThumbsWidth = 24;
                    myself.viewItemWidthRatio = 5;
                    myself.viewItemWidthMin = 200;
                    myself.viewItemWidthMax = 400;
                    if (myself.template && myself.template.view && myself.template.view.list && myself.template.view.list.size) {
                        myself.viewThumbsHeight = myself.template.view.list.size;
                        myself.viewThumbsWidth = myself.template.view.list.size;
                    }
                } else if (myself.view == 'icons') {
                    myself.viewThumbsHeight = 96;
                    myself.viewThumbsWidth = 96;
                    myself.viewItemWidthRatio = 1.35;
                    myself.viewItemWidthMin = 120;
                    myself.viewItemWidthMax = 300;
                    if (myself.template && myself.template.view && myself.template.view.icons && myself.template.view.icons.size) {
                        myself.viewThumbsHeight = myself.template.view.icons.size;
                        myself.viewThumbsWidth = myself.template.view.icons.size;
                    }
                } else if (myself.view == 'mosaic') {
                    myself.viewThumbsHeight = 64;
                    myself.viewThumbsWidth = 64;
                    myself.viewItemWidthRatio = 4;
                    myself.viewItemWidthMin = 200;
                    myself.viewItemWidthMax = 400;
                    if (myself.template && myself.template.view && myself.template.view.mosaic && myself.template.view.mosaic.size) {
                        myself.viewThumbsHeight = myself.template.view.mosaic.size;
                        myself.viewThumbsWidth = myself.template.view.mosaic.size;
                    }
                } else if (myself.view == 'preview') {
                    myself.viewThumbsHeight = 64;
                    myself.viewThumbsWidth = 64;
                    myself.viewItemWidthRatio = 0;
                    myself.viewItemWidthMin = 200;
                    myself.viewItemWidthMax = 400;
                    if (myself.template && myself.template.view && myself.template.view.mosaic && myself.template.view.mosaic.size) {
                        myself.viewThumbsHeight = myself.template.view.mosaic.size;
                        myself.viewThumbsWidth = myself.template.view.mosaic.size;
                    }
                }


                if (data.type == 'root') return true;
                // front lines
                var codeSubtext = [];
                if (data && myself.template && myself.template.view && myself.template.view.mosaic) {
                    $.each(myself.template.view.mosaic, (indexView, view) => {
                        if (data.data && data.data[view] && data.data[view] != data.label) {
                            codeSubtext.push(myself.renderSubdata(data.data[view], null, null, data));
                        }
                    });
                }
                var code = '<div class="' + currentClassAll + '"><div class="iv__item__frame"><span class="iv__item__link"><span class="iv__item__image">' + myself.renderIconImage('medium', data.icon, data, 'img') + '</span> '
                        + '<label class="iv__item__label">'
                        + '<span class="iv__item__name titre">' + data.label + '</span>'
                        + ((codeSubtext.length > 0) ? '<span class="iv__item__data infos">' + codeSubtext.join('') + '</span>' : '')
                        + '</label></span></div></div>';
                currentIcon = $(code);
                break;
            }

            if (!currentIconReact) currentIconReact = currentIcon;
            container.append(currentIcon);

            // properties
            $.each(data, (propertie, value) => {
                if (typeof propertie === 'string') {
                    currentIcon.data(propertie, value);
                }
            });
            if (data) {
                $.each(data, (propertie, value) => {
                    if (typeof propertie === 'string') {
                        currentIcon.data(propertie, value);
                    }
                });
            }
            currentIcon.data('type', currentType);
            currentIcon.data('plugin', myself);
            currentIcon.data('data', data);
            currentIcon.data('path', path);

            let iconClicksCount = 0;
            let iconClicksTimer = null;

            // Click handler
            currentIconReact.click(function (event) {
                let icon = $(this);
                if (!icon.hasClass('.iv__item')) {
                    icon = icon.closest('.iv__item');
                }

                // BLK click check
                let haveDblClick = false;
                const dblClickEvent = myself.options.event.doubleClick;
                if (dblClickEvent) {
                    if (myself.listTrigger.indexOf(dblClickEvent) == -1) {
                        if (icon.data('actions') && icon.data('actions')[dblClickEvent]) {
                            haveDblClick = true;
                        }
                    } else {
                        haveDblClick = true;
                    }
                }

                let trigger = 'leftClick';
                if (event.ctrlKey) trigger = 'ctrlClick';
                else if (event.altKey) trigger = 'altClick';
                else if (event.shiftKey) trigger = 'shiftClick';
                if (trigger != 'leftClick' || !haveDblClick || (trigger == 'leftClick' && myself.options.event.leftClick == 'select1')) { myself.iconTrigger(icon, trigger); } else {
                    iconClicksCount++; // Increment click counter
                    if (iconClicksCount === 1) { // Single click
                        iconClicksTimer = setTimeout(() => {
                            myself.iconTrigger(icon, trigger);
                            iconClicksCount = 0; // Reset
                        }, 200); // Increase or decrease if there is slowness or speed
                    } else { // Double click
                        clearTimeout(iconClicksTimer); // prevent single-click action
                        iconClicksCount = 0; // Reset
                    }
                }
            });

            currentIconReact.dblclick(function () {
                let icon = $(this);
                if (!icon.hasClass('.iv__item')) {
                    icon = icon.closest('.iv__item');
                }
                icon.data('plugin').iconTrigger(icon, 'doubleClick');
            });
            currentIcon.find('.iv__item__action button').click(function () {
                const button = $(this);
                const icon = $(this).closest('.iv__item')
                if (icon.data('actions')) {
                    const currentAction = icon.data('actions')[button.data('action')];
                    icon.data('plugin').action(currentAction, icon);
                }
            });

            // Right click
            currentIconReact.on('contextmenu', function () {
                let icon = $(this);
                if (!icon.hasClass('.iv__item')) {
                    icon = icon.closest('.iv__item');
                }

                myself.iconTrigger(icon, 'rightClick');
                return false;
            });

            // Media viewer support class
            if (data.file) {
                currentIcon.append('<a class="iv__item__preview imgbox" href="' + data.file + '" rel="iv__slideshow--' + myself.name + '" data-fancybox="iv__slideshow--' + myself.name + '" caption="' + data.label + '" data-caption="' + data.label + '"></a>');
            }

            // Menu
            let menuItems = [];
            if (data.actions) {
                $.each(data.actions, (propertie, value) => {
                    if (!value) return true;
                    let smallCurrentIcon = value.icon;
                    if (typeof smallCurrentIcon === 'object') smallCurrentIcon = smallCurrentIcon.small;
                    const menuItem = {
                        name: value.label,
                        icon: smallCurrentIcon,
                        callback(icon) {
                            const plugin = icon.data('plugin');
                            const grid = icon.closest('.iconGrid');
                            if (icon.hasClass('iv__item--selected') && grid.find('.iv__item--selected').length > 1) {
                                plugin.action(icon.data('actions')[propertie], grid, propertie);
                            } else {
                                plugin.action(icon.data('actions')[propertie], icon, propertie);
                            }
                        },
                    }
                    menuItems.push(menuItem);
                });

                if (menuItems.length) {
                    currentIcon.data('menu', menuItems);
                }
            }

            // Badge
            if (data.badge) {
                var badgeVal = data.badge.value;
                var badgeInput = $('<input class="iv__item__badge__input" type="number" min="0" value="'+badgeVal+'" />');
                var badgeWrap = $('<div class="iv__item__badge__wrap"></div>')
                var badge = $('<div class="iv__item__badge"></div>')
                badgeWrap.append(badgeInput);
                badge.append(badgeWrap);
                currentIcon.find('.iv__item__image').append(badge);

                this.applyQteClass(currentIcon);

                badgeInput.change(function() {
                    var field = data.badge.field;
                    var queryData = {};
                    queryData[field] = $(this).val();
                    myself.submitChange(data, queryData);
                    myself.applyQteClass(currentIcon);
                });

                badge.click(function(event) {
                    var spinnedInput = $(this).find('input');
                    spinnedInput.focus();
                    spinnedInput.select();
                    event.preventDefault();
                    event.stopPropagation();
                });

                badge.bind('touchstart mousedown', function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    if (event.type == 'touchstart') {
                        event = event.originalEvent.targetTouches[0];
                    }

                    myself.lockActions = true;

                    var spinnedInput = $(this).find('input');
                    var spinnedInputVal = $(this).find('.input-spinable-val');

                    spinnedInput.closest('.iv__item').addClass('iv__item--dragbadge');
                    spinnedInput.data('mouseY', event.pageY);
                    spinnedInput.data('value', spinnedInput.val());
                    spinnedInput.data('original', spinnedInput.val());

                    $(document).bind('touchmove mousemove', (event) => {
                        if (event.buttons || true) {
                            // document.body.style.cursor = "move !important";

                            if (event.type == 'touchmove') {
                                event = event.originalEvent.changedTouches[0];
                            }

                            let pxToChangeValue;

                            if (
                                parseInt(spinnedInput.val()) - parseInt(spinnedInput.data('value')) > 1
                                    || parseInt(spinnedInput.val()) - parseInt(spinnedInput.data('value')) < -1
                            ) {
                                pxToChangeValue = 20;
                            } else {
                                pxToChangeValue = 20;
                            }
                            // console.log("pxToChangeValue = "+pxToChangeValue);
                            const increment = parseInt((spinnedInput.data('mouseY') - event.pageY) / pxToChangeValue);
                            const newVal = parseInt(spinnedInput.data('value')) + increment;
                            spinnedInput.val(newVal);
                            if (spinnedInput.attr('min') && newVal < spinnedInput.attr('min')) {
                                spinnedInput.val(spinnedInput.attr('min'));
                            }
                            if (spinnedInput.attr('max') && newVal < spinnedInput.attr('max')) {
                                spinnedInput.val(spinnedInput.attr('max'));
                            }
                            if (increment != 0) {
                                spinnedInput.blur();
                                // clearSelection();
                            }
                            myself.applyQteClass(currentIcon);

                            spinnedInputVal.text(numberWithSpaces(spinnedInput.val()));
                        } else {
                            if (spinnedInput) {
                                spinnedInput.change();
                            }
                            $(document).unbind('touchmove mousemove');
                            spinnedInput = null;
                        }
                    });
                    $(document).bind('touchend mouseup', (event) => {
                        setTimeout(function() {
                            myself.lockActions = false;
                        }, 50)
                        if (spinnedInput) {
                            if (spinnedInput.data('original') != spinnedInput.val()) {
                                spinnedInput.change();
                            }
                            spinnedInput.closest('.iv__item').removeClass('iv__item--dragbadge');
                            $(document).unbind('touchmove mousemove');
                            // $(document).unbind('touchend mouseup');
                            // spinnedInput.select();
                            // spinnedInput.4s('.iv__item').data('count', spinnedInput.val());
                            spinnedInput = null;
                            // Inventaire.refreshChargeProcess();
                        }
                    });
                });
            }

            // VIEWS (END PROCESS)
            switch (myself.view) {
            // Table VIEW
            case 'tree':
            case 'blocks':
                if (iconData.childs && iconData.childs.length > 0) {
                    const childsCount = myself.renderIcons(iconData.childs, currentIconChilds, true, path);

                    if (childsCount > 0) currentIcon.addClass('iv__item--parent have-childs');

                    if (myself.dataExpand[iconData.type + '-' + iconData.id] == true) {
                        currentIcon.addClass('iv__item--expanded');
                    } else if (myself.dataExpand[iconData.type + '-' + iconData.id] === false) {
                    } else if (myself.options.expand) currentIcon.addClass('iv__item--expanded');
                    break;
                }
            }

            if (myself.items !== undefined) {
                myself.items.push(currentIcon);
                return currentIcon;
            }
            else {
                myself.render();
            }
        }
    };


IconsView.prototype.renderIconImage = function (size, icon, data, forceFill) {
        const iconDom = $('<div></div>');
        let fill = '';
            if (size == 'thumb') fill = 'cover';
            else if (size == 'logo') fill = 'contain';
        if (!icon) {
            icon = [this.options.sample.default.icon];
            fill = 'contain';
        }
        iconDom.icons({
            size,
            data: icon,
            fill,
        });
        return iconDom.html();
    }


IconsView.prototype.renderSubdata = function(rawVal, prefix, suffix, data) {
    if (!rawVal) return null;
    var itemValue, itemIcon, itemColor;
    if (typeof rawVal === 'string') {
        itemValue = rawVal;
    } else if (Array.isArray(rawVal)) {
        itemValue = rawVal[0] || '';
        itemIcon  = rawVal[1] || '';
        itemColor = rawVal[2] || '';
    } else if (typeof rawVal === 'object' && rawVal !== null) {
        itemValue = rawVal.value || '';
        itemIcon  = rawVal.icon  || '';
        itemColor = rawVal.color || '';
    }

    // Skip if value is empty
    if (!itemValue || (typeof itemValue === 'string' && itemValue.trim() === '')) {
        return null;
    }

    if (prefix) itemValue = prefix + (itemValue || '');
    if (suffix) itemValue = (itemValue || '') + suffix;

    var subdataHtml = '<span class="iv__item__subdata"'
        + ((itemColor) ? ' style="color:' + itemColor + ';"' : '')
        + '>';
    if (itemIcon) {
        subdataHtml += '<span class="iv__item__subicon">' + this.renderIconImage(24, itemIcon, data) + '</span>';
    }
    subdataHtml += (itemValue || '') + '</span>';
    return subdataHtml;
};

}
